import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE__radix_ui_react_label_49d956a0__ from "@radix-ui/react-label";
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
import * as __WEBPACK_EXTERNAL_MODULE__common_pdsTv_mjs_94e66c17__ from "../../../../../../common/pdsTv.mjs";
const input = (0, __WEBPACK_EXTERNAL_MODULE__common_pdsTv_mjs_94e66c17__.pdsTv)({
    base: [
        'ptw-peer ptw-h-[56px] ptw-rounded ptw-p-4 ptw-shadow-line ptw-shadow-surface-line',
        'hover:ptw-shadow-lineMedium hover:ptw-shadow-surface-text',
        'data-[error=true]:ptw-shadow-lineMedium data-[error=true]:ptw-shadow-error-base',
        'disabled:ptw-cursor-not-allowed disabled:ptw-bg-utils-transparent disabled:ptw-text-disabled-text disabled:ptw-shadow-line disabled:ptw-shadow-disabled-text',
        'focus:ptw-shadow-lineMedium focus:ptw-shadow-focus-line'
    ],
    variants: {
        hasAdornmentStart: {
            true: 'ptw-pl-[3rem]'
        },
        hasAdornmentEnd: {
            true: 'ptw-pr-[3rem]'
        }
    },
    slots: {
        wrapper: 'ptw-relative ptw-flex ptw-flex-col',
        label: [
            'ptw-pointer-events-none ptw-absolute ptw-left-4 ptw-top-[-0.625rem] ptw-bg-primary-text ptw-p-1 ptw-text-body-sm ptw-transition-all',
            'peer-disabled:ptw-text-disabled-text peer-data-[error=true]:ptw-text-error-base',
            'peer-focus:ptw-absolute peer-focus:ptw-left-4 peer-focus:ptw-top-[-0.625rem] peer-focus:ptw-p-1 peer-focus:ptw-text-body-sm peer-focus:ptw-text-focus-line peer-focus:ptw-transition-all',
            'peer-placeholder-shown:ptw-top-[calc(50%-0.75rem)] peer-placeholder-shown:ptw-p-0 peer-placeholder-shown:ptw-text-disabled-text',
            'peer-placeholder-shown:ptw-bg-primary-text peer-placeholder-shown:ptw-text-body-md'
        ],
        adornmentStart: 'ptw-flex-column ptw-absolute ptw-bottom-0 ptw-left-4 ptw-top-0 ptw-flex ptw-items-center',
        adornmentEnd: 'ptw-flex-column ptw-absolute ptw-bottom-0 ptw-right-4 ptw-top-0 ptw-flex ptw-items-center'
    }
});
const Input = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].forwardRef(({ label, labelProps, className, adornmentStart, adornmentEnd, ...props }, ref)=>{
    const { base, wrapper, label: labelCN, adornmentStart: adornmentStartCN, adornmentEnd: adornmentEndCN } = input({
        hasAdornmentStart: Boolean(adornmentStart),
        hasAdornmentEnd: Boolean(adornmentEnd)
    });
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
        className: wrapper(),
        children: [
            adornmentStart && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                className: adornmentStartCN(),
                children: adornmentStart
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("input", {
                placeholder: " ",
                ref: ref,
                className: base({
                    className
                }),
                ...props
            }),
            adornmentEnd && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                className: adornmentEndCN(),
                children: adornmentEnd
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_label_49d956a0__.Label, {
                className: labelCN(),
                ...labelProps,
                children: label
            })
        ]
    });
});
export { Input };
